<header-tabs [routes]="routes"></header-tabs>
<app-module-trial-banner module="booking"></app-module-trial-banner>
<div class="row" *ngIf="isSelected && isResponsive == true">
    <div class="col-12 text-center">
        <a class="btn-header-tab-responsive" style="background-color: #e3fd64;color:#1a1d23" (click)="onBack()">
            Volver
        </a>
    </div>
</div>

<ng-container *ngIf="isSelected || isResponsive == false">
    <router-outlet></router-outlet>
</ng-container>
